import { Box } from '@fhs-legacy/universal-components';

export const Actions = Box.withConfig({
  paddingY: '$4',
});
